module.exports = __webpack_public_path__ + "static/media/logo-wht.c6db9f1e.svg";